
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/download/prototyping/done",
      function () {
        return require("private-next-pages/download/prototyping/done/index.tsx");
      }
    ]);
  